/**
 * StaffPortalLeaveService
 * Service for staff leave operations in the portal.
 * Route: api/staff-portal/leaves
 */
import { StaffPortalBaseService } from './StaffPortalBaseService';
/**
 * StaffPortalLeaveService
 * Handles leave operations for the staff portal.
 * Maps to /api/staff-portal/leaves endpoint
 */
export class StaffPortalLeaveService extends StaffPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? StaffPortalLeaveService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? StaffPortalLeaveService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== LIST OPERATIONS ====================
    /**
     * Get all leave requests for the current staff member
     * GET /api/staff-portal/leaves
     */
    async getMyLeaves() {
        const response = await this.getMyLeavesRaw();
        return response.data ?? [];
    }
    /**
     * Get all leaves (raw response)
     */
    getMyLeavesRaw() {
        return this.get();
    }
    // ==================== GET SINGLE LEAVE ====================
    /**
     * Get a specific leave request by ID
     * GET /api/staff-portal/leaves/{leaveId}
     */
    async getLeave(leaveId) {
        const response = await this.getLeaveRaw(leaveId);
        if (!response.data) {
            throw new Error(`Leave ${leaveId} not found`);
        }
        return response.data;
    }
    /**
     * Get leave (raw response)
     */
    getLeaveRaw(leaveId) {
        return this.get(String(leaveId));
    }
    // ==================== CREATE OPERATIONS ====================
    /**
     * Create a new leave request
     * POST /api/staff-portal/leaves
     */
    async createLeave(data) {
        const response = await this.createLeaveRaw(data);
        if (!response.data) {
            throw new Error('Failed to create leave request');
        }
        return response.data;
    }
    /**
     * Create leave (raw response)
     */
    createLeaveRaw(data) {
        return this.post('', data);
    }
    // ==================== UPDATE OPERATIONS ====================
    /**
     * Update a pending leave request
     * PUT /api/staff-portal/leaves/{leaveId}
     */
    async updateLeave(leaveId, data) {
        const response = await this.updateLeaveRaw(leaveId, data);
        if (!response.data) {
            throw new Error('Failed to update leave request');
        }
        return response.data;
    }
    /**
     * Update leave (raw response)
     */
    updateLeaveRaw(leaveId, data) {
        return this.put(String(leaveId), data);
    }
    // ==================== CANCEL OPERATIONS ====================
    /**
     * Cancel a pending leave request (sets StatusID to -2)
     * PATCH /api/staff-portal/leaves/{leaveId}/cancel
     */
    async cancelLeave(leaveId) {
        const response = await this.cancelLeaveRaw(leaveId);
        if (!response.data) {
            throw new Error('Failed to cancel leave request');
        }
        return response.data;
    }
    /**
     * Cancel leave (raw response)
     */
    cancelLeaveRaw(leaveId) {
        return this.patch(`${leaveId}/cancel`);
    }
}
StaffPortalLeaveService.DEFAULT_SERVICE_PATH = 'leaves';
StaffPortalLeaveService.BASE_PATH = 'api/staff-portal/leaves';
//# sourceMappingURL=StaffPortalLeaveService.js.map